<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-task-manager v-if="temp" :entity="entity" :task="delete" stream-address="store/feature-group/stream-delete" :data="temp" :label="label" @close="reset" @cancel="reset" />
</template>
<script>
	import { FeatureGroup } from '@/modules/store/data/feature-group/list'
	import { FeatureGroupService } from '@/modules/store/services'
	export default {
		data()
		{
			return {
				temp: null
			}
		},
		computed:
		{
			entity()
			{
				return FeatureGroup;
			},

			service()
			{
				return new FeatureGroupService();
			},

			label()
			{
				return this.$loc.fromResource('action.delete');
			}
		},
		async beforeMount()
		{
			await this.init();
		},
		methods:
		{
			async init()
			{
				const store = this.$store;
				const router = this.$route;
				var temp = await store.dispatch('temp/findByQuery', router.query);
				if (temp)
				{
					this.temp = temp.value;
				}
				else this.$router.go(-1);
			},

			async delete(payload)
			{
				return await this.service.delete(payload['featureGroupId'], {HSR:false, HER:false});
			},
			
			reset()
			{
				this.$router.go(-1);
			}
		}
	}
</script>